<script setup>
import BirdsEyeImage from '@/components/BirdsEyeImage.vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const whiteEdge = '/home/img/white-edge.png'
const creatorProfile = '/home/img/rooms/creator-profile-riton.png'
const iconSearch = '/home/img/icon-search.svg'
const iconHome = '/home/img/icon-home.svg'
const iconFullsize = '/home/img/icon-fullsize.svg'
const iconReset = '/home/img/icon-reset.svg'

//hutch-putch-bettwasche-sets-ruschen-blush
const viewProduct = (product) => {
product.handle = 'hutch-putch-bettwasche-sets-ruschen-blush'
  router.push({ name: 'ProductView', params: { handle: product.handle } })
  // emit('selectProduct', product)
}
const viewBev = () => {
  router.push({ name: 'BirdsEyeView', params: { room_id: 'riton' } })
}

</script>
<template>
    <div class="viewer-outer-container">
        <div class="container viewer-container xfullscreen">
            <div class="image-viewer">

                <BirdsEyeImage />

                <div class="controls">
                    <button id="zoom-in-btn" class="control-btn hidden">
                        <img :src="iconSearch" alt="Zoom to 100%">
                    </button>
                    <button id="zoom-out-btn" class="control-btn" @click="viewBev">
                        <img :src="iconHome" alt="Reset Zoom">
                    </button>
                    <button id="fullscreen-btn" class="control-btn hidden">
                        <img :src="iconFullsize" alt="Fullscreen">
                    </button>
                    <button id="home-btn" class="control-btn hidden" @click="viewBev">
                        <img :src="iconReset" alt="Exit Fullscreen">
                    </button>
                </div>
            </div>
        </div>
        
        <!-- White Edge -->
        <img class="edge" :src="whiteEdge" width="75">
        <!-- Creator Picture -->
        <img class="creator" :src="creatorProfile" @click="viewBev" width="85">

    </div>
</template>
<style lang="scss" scoped>
.viewer-outer-container {
    margin-top: 100px;
}
img.creator {
    border-radius: 50%;
}
</style>
